<template lang="pug">
    .products-template
        .products-template-title
            p   {{ lenguageSelected.content1 }}
        .products-template-content
            .products-template-content-description
                p(v-for="item in lenguageSelected.content2")  {{ item }}
</template>

<script>
export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang
    },
    data: function(){
        return {
            lenguage: 'ES',
            lenguageEN: {
                content1: 'Mergers & Acquisitions',
                content2: [
                    'Whether it’s one or 1,000 towers, a metropolitan fiber network, or a portfolio of other digital infrastructure assets, we close deals quickly, and at competitive prices. For asset owners looking to generate income through partial or full portfolio sales, our M&A experts are committed to executing swift, fair transactions.',
                    'For more information on monetizing your assets, click the “Contact Us” button to your left.'
                ]
            },

            lenguageES: {
                content1: 'Fusiones y Adquisiciones (M&A)',
                content2: [
                    'Ya sea que se trate de una o 1,000 torres, una red de fibra óptica metropolitana, Small Cells o una cartera de otros tipos de activos de infraestructura digital, nos interesa evaluarla y hacerle una oferta. ATP lleva a cabo evaluaciones rápidas, a precios competitivos. Para los propietarios de activos que buscan generar ingresos a través de ventas parciales o completas de su portafolio, nuestros expertos en fusiones y adquisiciones están comprometidos a realizar transacciones rápidas y efectivas.',
                    'Para obtener más información sobre cómo generar flujos de efectivo con sus activos de infraestructura digital, seleccione el boton de la izquierda para ir a la sección de contacto.',
                ]
            }
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/molecules/PmWeBuy.vue